module.exports = __webpack_public_path__ + "img/para_compartir.91f254d9.jpg";